import script from "./UpCarCoaer.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpCarCoaer.vue?vue&type=script&lang=ts&setup=true"

import "./UpCarCoaer.vue?vue&type=style&index=0&id=69e82eff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e82eff"]])

export default __exports__